import React, { useEffect, useState, useCallback, useRef } from 'react'
import styled from 'styled-components'
import Sidebar from '../../templates/Sidebar'
import Navbar from '../../templates/Navbar'
import { useAppDispatch, useAppSelector } from '../../../Redux/Hooks'
import { getUserByToken } from '../../../Redux/ApiCalls/Auth/login'
import { Outlet, useNavigate, useLocation } from 'react-router-dom'
import { clearError, clearToken } from '../../../Redux/Slice/Auth/AuthSlice'
import { showErrorToast } from '../../atoms/Utlis/Toast'
import { getAllUnseenNotificationAPI } from '../../../Redux/ApiCalls/Dashboard/NotificationAPI'
import ProgressSnackbar from '../../atoms/Dashboard/Folder/FolderProgressbar'
import { getBusinessDetailsAPI, getUserActivePlanAPI } from '../../../Redux/ApiCalls/Auth/user'
import sendFirebaseEvent from '../../../analytics/FirebaseAnalytics'
import { trackClarityEvent } from '../../../analytics/ClarityAnalytics'
import { CLARITY_EVENTS } from '../../../analytics/EventTypes'
import { scheduleResumePendingFolderUploads } from '../../../Utils/folderUploadResume'
import { getMyPermissionsAPI } from '../../../Redux/ApiCalls/Dashboard/RoleApi'
import { usePermissions } from '../../../hooks/usePermissions'
import DashboardTermsModal from '../../organisms/Dashboard/DashboardTermsModal'
import {
    getPlanExpiryAlertAPI,
    dismissPlanExpiryAlertAPI,
    PlanExpiryAlertData,
} from '../../../Redux/ApiCalls/Dashboard/SubscriptionAPI'
import { SubscriptionExpiryAlertModal } from '../../organisms/Dashboard/SubscriptionExpiryAlertModal'

const DashboardContainer = styled.div`
display:flex;
flex-direction:column;
background: #f7f7f7;
position: relative;
overflow: hidden;
width: 100%;
height: 100dvh;
`
const MainConatiner = styled.div`
display:flex;
flex-direction:row;
background: transparent;
position: relative;
overflow: hidden;
width: 100%;
height: 100%;
z-index:1;
`;
const MainSection = styled.div<{ isExpand: boolean }>`

display:flex;
width: ${props => props.isExpand ? '81%' : '96%'};
transition:all 0.3s ease-in-out;
flex-direction:column;
overflow-y: auto;
flex-grow: 1;
`
const GradientDiv1 = styled.div`
width: 661px;
height: 661px;
position:absolute;
top: -273px;
left: 1413px;
opacity: 50%;
background: #f7f7f7;
overflow: hidden;

`
const GradientDiv2 = styled.div`
width: 661px;
height: 661px;
position:absolute;
top: 757px;
left: 70px;
opacity: 50%;
background: #f7f7f7;
overflow: hidden;
// z-index: -1;
`

const GradientDiv3 = styled.div`
width: 900px;
height: 900px;
position:absolute;
top: 119px;
left: 600px;
gap: 0px;
opacity: 0.4;
background: radial-gradient(50% 50% at 50% 50%, rgba(90, 81, 191, 0.7) 0%, rgba(90, 81, 191, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
// z-index:-1;
`
const MainPage = styled.div`
overflow-x: hidden;
flex-grow: 1;
min-height: 0;
display: flex;
flex-direction: column;
`
const Dashboard: React.FC = () => {
    const { isAuthenticated, user, access_token, refresh_token, isError, error, isUserChanged, dashboard_terms } = useAppSelector(state => state.auth);
    const { myPermissions } = useAppSelector(state => state.role);
    const navigate = useNavigate()
    const [isExpand, setIsexpand] = useState(true);
    const toggelExpand = () => {
        const newExpandState = !isExpand;
        setIsexpand(newExpandState);
        trackClarityEvent(
            newExpandState ? CLARITY_EVENTS.SIDEBAR_EXPANDED : CLARITY_EVENTS.SIDEBAR_COLLAPSED,
            {}
        );
    }
    const dispatch = useAppDispatch();
    const { isStudioOwner, isSubUser, studioRole, permissions, permissionsLoading, hasModule, hasPermission } = usePermissions();
    const location = useLocation();

    const [planExpiryAlert, setPlanExpiryAlert] = useState<PlanExpiryAlertData | null>(null);
    const expiryAlertFetchedRef = useRef(false);

    const normalizedPath = location.pathname.replace(/\/+$/, '');
    const isDashboardOrSubscriptionPage =
        normalizedPath === '/dashboard' ||
        normalizedPath === '/dashboard/subscriptions';

    const showTermsModal = Boolean(
        dashboard_terms &&
        dashboard_terms.requires_terms_acceptance &&
        !dashboard_terms.dashboard_terms_accepted
    );

    useEffect(() => {
        if (!isAuthenticated) return;
        if (!isDashboardOrSubscriptionPage) return;
        if (expiryAlertFetchedRef.current) return;

        if (!isStudioOwner && !hasModule('SUBSCRIPTIONS') && !hasPermission('subscriptions.read')) return;

        expiryAlertFetchedRef.current = true;
        getPlanExpiryAlertAPI()
            .then((data) => {
                if (data && data.show_alert) {
                    setPlanExpiryAlert(data);
                } else {
                    setPlanExpiryAlert(null);
                }
            })
            .catch(() => {
                // Non-blocking
            });
    }, [isAuthenticated, isDashboardOrSubscriptionPage, isStudioOwner, hasModule, hasPermission]);

    const handleDismissPlanAlert = async () => {
        if (!planExpiryAlert) return;
        const currentStage = planExpiryAlert.stage;
        setPlanExpiryAlert(null);
        try {
            await dismissPlanExpiryAlertAPI(currentStage);
        } catch (err) {
            // Non-blocking
        }
    };

    const handleRenewPlan = async () => {
        if (!planExpiryAlert) return;
        const currentStage = planExpiryAlert.stage;
        setPlanExpiryAlert(null);
        try {
            await dismissPlanExpiryAlertAPI(currentStage);
        } catch (err) {
            // Non-blocking
        }
        navigate('/dashboard/subscriptions');
    };

    useEffect(() => {
        if (isError) {
            console.log("error in loadind dashboard")
            console.log(error)
            // navigate('/auth/login')
        }

        //   check user is Auth ?
        // 1. yes then fetch data from user redux object 
        // 2. no then check there is accesstoken pr not in localstorage 
        // // console.log(!isAuthenticated && !user && !access_token)
        // // console.log("+++++++++++++++++++++++++++++")
        // 3. If there is no acces token or isAuthenticated is true the redirect to loginpage
        if (!isAuthenticated && !user && !access_token) {
            if (localStorage.getItem('access_token')) {
                dispatch(getUserByToken());
            } else {
                navigate('/auth/login');
            }
        }
        return () => {
            dispatch(clearError());
        }
    }, [isError, isAuthenticated, dispatch])
    useEffect(() => {
        if (isUserChanged) {
            dispatch(getUserByToken());
        }
    }, [isUserChanged])
    useEffect(() => {
        if (isAuthenticated) {
            if (isStudioOwner || hasModule('SUBSCRIPTIONS') || hasPermission('subscriptions.read')) {
                dispatch(getUserActivePlanAPI());
            }
            if (isStudioOwner) {
                dispatch(getBusinessDetailsAPI());
            }
            dispatch(getMyPermissionsAPI());
        }
    }, [isAuthenticated, isStudioOwner, dispatch])

    // If a team member's role was unassigned/removed, log them out immediately
    useEffect(() => {
        if (isAuthenticated && isSubUser && !permissionsLoading && myPermissions !== null) {
            if (!studioRole && (!permissions || permissions.length === 0)) {
                showErrorToast("Your role has been removed. You have been logged out.");
                dispatch(clearToken());
                navigate('/auth/login');
            }
        }
    }, [isAuthenticated, isSubUser, permissionsLoading, studioRole, permissions, myPermissions, dispatch, navigate])

    // Periodically re-check permissions and check on focus for sub-users
    useEffect(() => {
        if (!isAuthenticated || !isSubUser) return;

        const onFocus = () => {
            dispatch(getMyPermissionsAPI());
        };
        window.addEventListener("focus", onFocus);

        const interval = setInterval(() => {
            dispatch(getMyPermissionsAPI());
        }, 30000);

        return () => {
            window.removeEventListener("focus", onFocus);
            clearInterval(interval);
        };
    }, [isAuthenticated, isSubUser, dispatch])
    // Resume folder uploads after page refresh
    useEffect(() => {
        if (isAuthenticated && access_token) {
            scheduleResumePendingFolderUploads()
        }
    }, [isAuthenticated, access_token])
    useEffect(() => {
        sendFirebaseEvent('Dashboard', 'Preview_Page', 'Load_Dashboard', 'Load_Dashboard')
        trackClarityEvent(CLARITY_EVENTS.DASHBOARD_LOADED, {
            isAuthenticated,
            hasUser: !!user,
        })
    }, [])
    return (
        <DashboardContainer>
            {/* <GradientDiv3 /> */}
            <GradientDiv1 />
            <GradientDiv2 />
            <MainConatiner>

                <Sidebar isExpand={isExpand} toggelExpand={toggelExpand}></Sidebar>
                <MainSection isExpand={isExpand}>

                    <Navbar />
                    <MainPage>
                        <Outlet />
                    </MainPage>
                </MainSection>
                <ProgressSnackbar />
            </MainConatiner>

            {showTermsModal && dashboard_terms && (
                <DashboardTermsModal terms={dashboard_terms} />
            )}

            {!showTermsModal && isDashboardOrSubscriptionPage && planExpiryAlert && planExpiryAlert.show_alert && (
                <SubscriptionExpiryAlertModal
                    alertData={planExpiryAlert}
                    onClose={handleDismissPlanAlert}
                    onRenew={handleRenewPlan}
                />
            )}
        </DashboardContainer>
    )
}

export default Dashboard